
import { Suspense } from 'react';
import { useLocation } from 'react-router';
import { General } from './general.routes';
import { LocalStorageService, TOKEN } from '../services/LocalStorageService';
import { LoadingPage } from '@/components/LoadingPage';
import { lazyNamed } from '@/utils/staleChunk';

const Backoffice = lazyNamed(() => import('./backoffice.routes'), 'Backoffice');

const getTokenFromLocalStorage = (): string | null => {
  try {
    return LocalStorageService.get<string>(TOKEN);
  } catch (error) {
    console.error('Error accessing localStorage:', error);
    LocalStorageService.clearAll();
    return null;
  }
};

const hasSysadminPath = (path: string): boolean => {
  return path.includes('sysadmin') || path.includes('sysadmin/home');
};

export const Routes = () => {
  const location = useLocation();
  const isPrivateRoute = getTokenFromLocalStorage() && hasSysadminPath(location.pathname);

  if (isPrivateRoute) {
    return (
      <Suspense fallback={<LoadingPage message="Carregando..." />}>
        <Backoffice />
      </Suspense>
    );
  }

  return <General />;
};
